<div class="login_page_wrapper login-div">
    <div class="background-image" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag 
    && !sportz_village_flag && !al_hilal_flag && !al_shabab_flag && !yalla_goal_flag && !sports_pad_flag">
        <img class="img-fluid" src="assets/images/bg-1.jpg"  />  
    </div>   
    <div class="background-image" *ngIf="sos_login_flag">
        <img class="img-fluid1" src="assets/images/sos-background.png"  />  
    </div> 
    <div class="background-image" *ngIf="datastream_flag" style="background: black;padding-top: 4.5%;">
        <img class="img-fluid" src="assets/images/datastream.png"  style="background: black;"/>  
    </div>
    <div class="background-image" *ngIf="mahd_flag">
        <img class="img-fluid" src="assets/images/MahdLogin.png" style="height: 100%;" />  
    </div>
    <div class="background-image sportz-village" *ngIf="sportz_village_flag" style="background: white;">
        <img class="img-fluid1" src="assets/images/SVLogin.png" />  
    </div>
    <div class="background-image" *ngIf="al_hilal_flag" style="background: white;">
        <img class="img-fluid1" src="assets/images/alHilalLogin.jpg" />  
    </div>
    <div class="background-image" *ngIf="al_shabab_flag" style="background: white;">
        <img class="img-fluid1" src="assets/images/Al_shabab.png" />  
    </div>
    <div class="background-image" *ngIf="yalla_goal_flag" style="background: white;">
        <img class="img-fluid1" src="assets/images/yalla_goal.png" />  
    </div>
    <div class="background-image" *ngIf="sports_pad_flag" style="background: white;">
        <img class="img-fluid1" src="assets/images/sportspadbag.png" />  
    </div>


    <div class="adjustment-div" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag && !sportz_village_flag
        && !al_hilal_flag && !al_shabab_flag && !yalla_goal_flag && !sports_pad_flag">
        <p class="" style="text-align:center; margin-top:70px; margin-bottom:20px; float:left; width:100%;">
            <span class="acad-img">
                <img  src="assets/images/acadware_logo_vme_white.png" alt="Acadware" style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;">{{'Login' | translate }}</h2>
                </div>

                <!-- <div>
                    <h2>{{ 'HOME.TITLE' | translate }}</h2>
                    <label>
                      {{ 'HOME.SELECT' | translate }}
                      <select #langSelect (change)="translate.use(langSelect.value)">
                        <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</option>
                      </select>
                    </label>
                  </div> -->
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline" style="line-height: 20px;">  
                                <mat-label>{{'EMAIL' | translate }} / {{'MOBILE' | translate}} </mat-label>                      
                                <input matInput formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">{{'validEmailMobileErrorMsg' |translate}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #9ce0ec;;color: black;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;">{{'ForgotPassword' | translate}}</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #13b8d5;">{{'Submit' | translate}}</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color: #13b8d5;">{{'Login' | translate}}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">{{'term' | translate}}
                <a (click)="openTermsCondition()" style="color:#f0ff24;">{{'termOfUse' | translate}}</a>
            </p> 
            <p> <a style="color:#fff;">REQUEST</a>
                <a [routerLink]="['/data-deletion-req']" style="color:#f0ff24;"> DATA DELETION</a>
            </p>

            <!-- <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">{{'LanguageOffered' | translate}}:
                <a (click)="changeLocale('en')" style="color:#f0ff24;">English </a>|
                <a (click)="changeLocale('hi')" style="color:#f0ff24;">हिन्दी</a>
            </p>        -->
        </div>
    </div>
    <div class="sos-adjustment-div" *ngIf="sos_login_flag">             
        <p class="logo-sos" style="text-align:center;   margin-bottom:20px; float:left; width:100%;">
            <span class="acad-img" >
                <img  src="assets/images/sos-logo.png"  style="width:265px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 0px;background-color: rgba(65,67,66);">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content" style="padding: 0px !important;">   
                <mat-tab-group>
                    <mat-tab label="Login">

                        <form class="md-float-material" [formGroup]="login_form" >
                            <div class="example-container" style="padding: 20px;">
                                <div>
                                    <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                                </div>
                                
                                <mat-form-field appearance="outline" style="background-color: rgb(51,51,51);">  
                                    <mat-label style="color: white;">Email address / Mobile</mat-label>                      
                                    <input matInput class="user" style="color: white;" autocomplete="off" formControlName="Email" (change)="checkEmailorMobile($event.target.value);" (keyup)="usercredentialEnter()" required>
                                    <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 18px;color:#f0ff24">Please Enter a Valid Email Address or Mobile Number</mat-error>
                                </mat-form-field> 
                               
                                <mat-form-field appearance="outline" style="margin-top:18px;background-color: rgb(51,51,51);">   
                                    <mat-label style="color: white;">{{dynamic_label}}</mat-label>                      
                                    <input matInput name="Password" class="user" style="color: white;" autocomplete="off" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 18px;color:#f0ff24">Please Enter Your {{dynamic_label}}</mat-error>
                                </mat-form-field>
                                
                                <div style="text-align:right; float:left; width:100%;">
                                    <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600" style=" float:right; margin-bottom:30px;color:#f0ff24"> Forgot Password?</a>
                                </div>
                                <!-- <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="email_div">
                                    <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #13b8d5;">Submit</button>
                                </div> -->
                                <div class="button-row" style="text-align:center; margin-top:10px;" >
                                    <button mat-raised-button (click)="checkUserId(login_form.value);addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color: rgb(255,240,43);border-radius: 30px;width: 100%;height: 45px;">Login</button>
                                </div>
                            </div>
                        </form>
                    </mat-tab>
                    <mat-tab label="" disabled></mat-tab>
                 
                  </mat-tab-group>            
               
               
            </div>
        </div>
        <div class="uk-margin-top uk-text-center" style="position:relative;border-top: 2px solid white;">          
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="sos_term()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>        
        </div>
    </div>
    <div class="adjustment-div" *ngIf="datastream_flag">
        <p class="" style="text-align:center; margin-top:6px; margin-bottom:210px; float:left; width:100%;">
           
            <span class="acad-img">
                <img  src="assets/images/datastreamLogo.png" alt="Acadware" style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: rgb(112,77,159);">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: rgb(193, 157, 242);color: black;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: rgb(112,77,159);">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:rgb(112,77,159)">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="openTermsCondition()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>  
            
                
        </div>
        
    </div>
    <div class="adjustment-div" *ngIf="mahd_flag">
        <p class="" style="text-align:center; margin-top:6px; float:left; width:100%;">
           
            <span class="acad-img">
                <img  src="assets/images/MahdAcademy.png"  style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: rgb(112,77,159);">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: rgb(193, 157, 242);color: black;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: rgb(112,77,159);">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:rgb(112,77,159)">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="openTermsCondition()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>        
        </div>
    </div>
    <div class="adjustment-div" *ngIf="sportz_village_flag">
        <p class="" style="text-align:center; margin-top:20px; margin-bottom:155px; float:left; width:100%;">
           
            <span class="acad-img">
                <img  src="assets/images/SV.png" alt="Acadware" style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: #026EB0;">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #026EB0;color: white;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer;color: white;" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #026EB0;">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:#026EB0">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag && !sportz_village_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="openTermsCondition()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>        
        </div>
    </div>
    <div class="adjustment-div" *ngIf="al_hilal_flag">
        <p class="" style="text-align:center; margin-top:6px; float:left; width:100%;">
           
            <span class="acad-img">
                <img  src="assets/images/alhilal-logo.png"  style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: #201B54;">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #201B54;color: white;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer;color: white;" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #201B54;">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:#201B54">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag && !al_hilal_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="openTermsCondition()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>        
        </div>
    </div>
    <div class="adjustment-div" *ngIf="al_shabab_flag">
        <p class="" style="text-align:center; margin-top:6px; float:left; width:100%;margin-bottom: 105px;">
           
            <span class="acad-img">
                <img  src="assets/images/shabab-logo.png"  style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: #974846;">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #974846;color: white;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer;color: white;" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #974846;">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:#974846">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
        <div class="uk-margin-top uk-text-center" style="position:relative" *ngIf="!sos_login_flag && !datastream_flag && !mahd_flag && !al_hilal_flag && !al_shabab_flag">
            <!-- <p class="text-right" style="color:#fff; text-align:center;">Don't have an account?
                <a [routerLink]="['/register']" style="color: #13b8d5;"> Register </a> here!</p> -->
            <p class="text-right" style="color:#fff; text-align:center;margin-top: 10px;">BY CONTINUING,YOU AGREE TO OUR
                <a (click)="openTermsCondition()" style="color:#f0ff24;">TERMS OF USE</a>
            </p>        
        </div>
    </div>

    <div class="adjustment-div" *ngIf="yalla_goal_flag">
        <p class="" style="text-align:center; margin-top:6px; float:left; width:100%;">
           
            <span class="acad-img">
                <img  src="assets/images/yalla_goal_logo.png"  style="width:215px;" />
            </span>
        </p>
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: #568B3F;">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #568B3F;color: white;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer;color: white;" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #568B3F;">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:#568B3F">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
     
    </div>

    <div class="adjustment-div" *ngIf="sports_pad_flag">
        <p class="" style="text-align:center; margin-top:6px; float:left; width:100%;">           
            <span class="acad-img">
                <img  src="assets/images/sportspadIcon.png"  style="width:130px;margin-top: 5px;" />
            </span>
        </p>

        
        <div class="md-card" id="login_card" style="clear:both;border-radius: 7px;">            
            <div class="md-card-toolbar-actions">
                <div [style.display]="spinner_div" style="float:left; width:100%;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
            </div>

            <div class="md-card-content large-padding" id="login_form">               
                <div class="login_heading">
                    <h2 style="margin:0px 0px 20px 0px;color: #EF7021;">Login</h2>
                </div>
               
                <form class="md-float-material" [formGroup]="login_form" >
                    <div class="example-container">
                        <div>
                            <mat-error *ngIf="errorMessage" style="text-align:center; line-height:25px;">{{ errorMessage }}</mat-error>
                        </div>
                        <div [style.display]="email_div">
                            <mat-form-field appearance="outline">  
                                <mat-label>Email address / Mobile</mat-label>                      
                                <input matInput placeholder="Email address / Mobile" formControlName="Email" (change)="checkEmailorMobile($event.target.value)" (keyup)="usercredentialEnter()" required>
                                <mat-error *ngIf="!login_form.controls['Email'].valid && login_form.controls['Email'].touched" style="margin-top: 15px;">Please Enter a Valid Email Address or Mobile Number</mat-error>
                            </mat-form-field>
                        </div>
                        <div [style.display]="password_div">
                            <div style="text-align: center; float: none;">
                                <mat-chip-list style="margin: 0px auto;float: none; display: inline-block;">
                                    <mat-chip style="background-color: #EF7021;color: white;word-break: break-all;min-height: 40px !important;">{{email}} &nbsp;
                                        <i class="material-icons" style="cursor: pointer;color: white;" title="Change Email" (click)="changeEmail()">close</i>
                                    </mat-chip>                            
                                </mat-chip-list>
                            </div>
                        <mat-form-field appearance="outline" style="margin-top:18px;">   
                            <mat-label>{{dynamic_label}}</mat-label>                      
                            <input matInput placeholder="Password" formControlName="Password" [type]="hide ? 'password' : 'text'" (keyup)="usercredentialEnter()" autocomplete="off">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="!login_form.controls['Password'].valid && login_form.controls['Password'].touched" style="margin-top: 15px;">Please Enter Your {{dynamic_label}}</mat-error>
                        </mat-form-field>
                        </div>
                        <div style="text-align:right; float:left; width:100%;" [style.display]="password_div">
                            <a [routerLink]="['/forgot']" (click)="forgotPassword()" class="text-right f-w-600 text-danger" style=" float:right; margin-bottom:30px;"> Forgot Password?</a>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:20px;" [style.display]="email_div">
                            <button mat-raised-button color="primary" (click)="checkUserId(login_form.value)" style="background-color: #EF7021;">Submit</button>
                        </div>
                        <div class="button-row" style="text-align:center; margin-top:10px;" [style.display]="password_div">
                            <button mat-raised-button color="primary"  (click)="addPost(login_form.value)" type="submit" [disabled]="login_btn" style="background-color:#EF7021">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>        
     
    </div>
    
</div>

<ng-template #term_conditon>
    <h4 mat-dialog-title>TERMS OF USE
        <button mat-icon-button [mat-dialog-close]=" " style="float:right;" (click)="cancel()">
            <mat-icon aria-hidden="false">close</mat-icon>
        </button>
    </h4> 
    <mat-dialog-content>
        <p *ngIf="term_conditon_data" [innerHTML]="term_conditon_data.content"></p>  
    </mat-dialog-content>    
    <mat-dialog-actions>  
        <button mat-raised-button color="primary" [mat-dialog-close]=" " style="background-color:#13b8d5;" (click)="cancel()" >Cancel</button>
    </mat-dialog-actions>
  </ng-template>